module.exports = __webpack_public_path__ + "static/img/MU.91d0bded.png";